import { Box, Button, Dialog, DialogContent, DialogTitle, IconButton, Stack } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import axios from "axios";
import { useState } from "react";
import { CloseIcon } from "../../minimals/theme/overrides/CustomIcons";
import { RequestedTaskDescription } from "./types";

interface Props {
  currentEta?: string | null;
  isOpen: boolean;
  onClose: () => void;
  onSaved: () => Promise<void>;
  orderNumber: string;
  orderNumberDisplay: string;
  taskDescriptions: RequestedTaskDescription[];
}

export default function EditRequestedTaskEtaModal({
  currentEta,
  isOpen,
  onClose,
  onSaved,
  orderNumber,
  orderNumberDisplay,
  taskDescriptions
}: Props) {
  const [submitting, setSubmitting] = useState(false);
  const [selectedEta, setSelectedEta] = useState<Date | null>(currentEta ? new Date(currentEta) : null);

  const saveEta = async () => {
    for (const taskDescription of taskDescriptions) {
      await axios.post("/proxy/api/requestedtasks/update", {
        orderNumber,
        task: {
          description: taskDescription,
          dueDate: selectedEta
        }
      });
    }
  };

  const save = async () => {
    setSubmitting(true);

    try {
      await saveEta();
      await onSaved();
      onClose();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={isOpen} onClose={submitting ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Stack direction="row" spacing={2} alignItems="center" marginBottom={3}>
          <Box>Edit ETA for Order {orderNumberDisplay}</Box>
        </Stack>
      </DialogTitle>
      <IconButton
        onClick={onClose}
        disabled={submitting}
        sx={{ position: "absolute", right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ paddingBottom: 3 }}>
        <Box paddingTop={1}>
          <DatePicker value={selectedEta} onChange={setSelectedEta} />
          <Stack direction="row" justifyContent="right" marginTop={2}>
            <Button variant="contained" size="small" onClick={save} disabled={submitting}>
              {submitting ? "Saving..." : "Save"}
            </Button>
          </Stack>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
